import { QUOTE_TYPE } from 'types/bulkUpload';
import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import QuoteTypeSelector from '../DownloadQuotesStep0/components/QuoteTypeSelector/QuoteTypeSelector';
import { downloadUploadInfo, uploadTemplateInfoWithErrors } from '../../content/donwloadUploadInfo';
import './DownloadQuotesStep1.scss';

interface DownloadQuotesStep1Props {
  selectedQuoteType?: QUOTE_TYPE;
  setSelectedQuoteType: (quoteType: QUOTE_TYPE) => void;
  templateUrlWithErrors?: string;
  handleSubmitUploadForm: (file: File) => Promise<void>;
}
const DownloadQuotesStep1 = ({
  selectedQuoteType,
  setSelectedQuoteType,
  templateUrlWithErrors,
  handleSubmitUploadForm
}: DownloadQuotesStep1Props) => {
  const renderUploadInfo = !!templateUrlWithErrors
    ? uploadTemplateInfoWithErrors(templateUrlWithErrors)
    : downloadUploadInfo;
  return (
    <UploadForm
      uploadInfo={renderUploadInfo}
      backLink="/bulk-upload/type-of-charge"
      fileInputIsDisabled={!selectedQuoteType}
      customClassName="downloadUploadQuotesFormStep1"
      onSubmit={handleSubmitUploadForm}
      customContentBeforeOptions={
        <QuoteTypeSelector
          selectedQuoteType={selectedQuoteType ?? QUOTE_TYPE.REGULAR}
          onSelectQuoteType={setSelectedQuoteType}
        />
      }
    />
  );
};

export default DownloadQuotesStep1;
